<template>
  <div class="curr-month-overview">
    <div class="flex-align-center">
      <div class="record-title">多次提醒学生班主任关怀情况</div>
    </div>
    <div class="flex-between" style="margin-top: 20px">
      <div class="flex-align-center">
        <span class="title-1">
          {{ twoRemindTitle }}
        </span>
        <span style="color: #9599a2">
          <span>
            已关怀：{{ dataSourceExtra.twoManyRemindStudentCareHaveDealCount }}人 ({{
              dataSourceExtra.twoManyRemindStudentCareRate
            }}%)
          </span>
          <span style="margin: 0 10px">|</span>
          <span>
            未完整关怀：{{ dataSourceExtra.twoManyRemindStudentCareNotAllDealCount }}人 ({{
              dataSourceExtra.twoManyRemindStudentCareNotAllDealRate
            }}%)
          </span>
        </span>
      </div>
      <div style="color: #2a82e4; cursor: pointer" @click="viewModal">
        查看详情
        <a-icon type="right" />
      </div>
    </div>
    <div class="tip" style="margin: 12px 0 5px">
      <span>
        <img
          src="@/assets/imgs/school/monthRecord/warningMark.png"
          alt=""
          style="width: 14px; height: 14px; margin-right: 5px"
        />
        未完整关怀的{{ dataSourceExtra.twoManyRemindStudentCareNotAllDealCount }}人中，{{
          dataSourceExtra.twoManyRemindStudentCareDealOnceCount
        }}人仅关怀1次，{{
          dataSourceExtra.twoManyRemindStudentCareNotDealCount
        }}人尚未关怀，建议年级组长3个工作日内督促班主任完成跟进,并将情况反馈至心理中心。
      </span>
    </div>
    <TableList
      style="width: 100%"
      :columns="twoColumns"
      :tableData="dataSource"
      :loading="loading"
      :scroll="{}"
    />
    <div style="margin-top: 15px">
      注：完整名单共{{ ipagination.total }}人，此处展示部分未完整关怀学生及代表性已关怀学生
    </div>
    <div class="flex-between" style="margin: 20px 0 5px">
      <div class="title-1">三次及以上提醒学生（{{ threeTotal }}人）</div>
      <a-tag color="red">高风险</a-tag>
    </div>
    <TableList
      style="width: 100%"
      :columns="threeColumns"
      :tableData="threeDataSource"
      :loading="threeLoading"
      :scroll="{}"
    />
    <!--详情模态框-->
    <DetailModal ref="detailModalRef" :title="twoRemindTitle" :columns="twoColumns" :url="url" />
  </div>
</template>
<script>
import CountAnimation from '@/components/CountAnimation'
import TableList from '@comp/chart/TableList.vue'
import DetailModal from './DetailModal.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { queryTwoManyThreeRemindStudentCareList } from '@/api/monthReport'

export default {
  name: 'RemindCaringSituation',
  mixins: [JeecgListMixin],
  components: {
    CountAnimation,
    TableList,
    DetailModal,
  },
  props: {
    dateRange: {
      type: Object,
      default: () => ({}),
    },
    dataSourceExtra: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 再次提醒学生数据
      url: {
        list: '/emotionalReport/queryTwoManyRemindStudentCareList',
        exportXlsUrl: '/emotionalReport/queryTwoManyRemindStudentCareExport',
      },
      disableMixinCreated: true,
      twoColumns: [
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '姓名',
          dataIndex: 'studentName',
          align: 'center',
        },
        {
          title: '本月提醒次数',
          dataIndex: 'remindCount',
          align: 'center',
        },
        {
          title: '已关怀次数',
          dataIndex: 'dealCount',
          align: 'center',
        },
        {
          title: '操作建议',
          dataIndex: 'suggestion',
          align: 'center',
          customRender: (_, record) => {
            return (
              <div style={{ color: record.dealCount == 0 && '#236CFE' }}>{record.suggestion}</div>
            )
          },
        },
      ],
      threeColumns: [
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '姓名',
          dataIndex: 'studentName',
          align: 'center',
        },
        {
          title: '本月提醒次数',
          dataIndex: 'remindCount',
          align: 'center',
        },
        {
          title: '已关怀次数',
          dataIndex: 'dealCount',
          align: 'center',
        },
        {
          title: '处理情况',
          dataIndex: 'careFlag',
          align: 'center',
        },
        {
          title: '下一步措施',
          dataIndex: 'suggestion',
          align: 'center',
          customRender: (_, record) => {
            return <div style="color:#236CFE">{record.suggestion}</div>
          },
        },
      ],
      threeDataSource: [],
      threeLoading: false,
      threeTotal: 0,
    }
  },
  watch: {
    dateRange(dateObj) {
      this.queryParam = {
        startTime: dateObj.beginDate,
        endTime: dateObj.endDate,
      }
      this.loadData(1)
      this.queryTwoManyThreeRemindStudentCareList()
    },
  },
  computed: {
    twoRemindTitle() {
      return `两次提醒学生（${this.dataSourceExtra.twoManyRemindStudentCount || 0} 人）`
    },
  },
  methods: {
    async queryTwoManyThreeRemindStudentCareList() {
      this.threeLoading = true
      const { success, result } = await queryTwoManyThreeRemindStudentCareList({
        ...this.queryParam,
        pageNo: 1,
        pageSize: 20,
      })
      this.threeLoading = false
      if (success) {
        this.threeDataSource = result.records
        this.threeTotal = result.total
      }
    },
    viewModal() {
      this.$refs.detailModalRef.showModal(this.queryParam)
    },
    immediateCare(record) {},
    followUp(record) {},
  },
}
</script>
<style scoped lang="less">
.curr-month-overview {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  .tip {
    padding: 15px;
    border-radius: 10px;
    line-height: 1.8;
    background-color: #fdfde5;
  }
}
</style>
